import React, { useState, useRef } from 'react';
import { FormControl, FormHelperText, CircularProgress, TextField, Container, Typography, InputLabel, Paper, Toolbar, Select, MenuItem, Divider, Radio, RadioGroup, Button, Grid, Box  } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { AccountActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const accountsSelector = (state) => state.Accounts;
const IdentitySelector = (state) => state.Identity;

const AccountEdit = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const accountActions = bindActionCreators(AccountActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(accountsSelector);
    const { token, userData } = useSelector(IdentitySelector);

    // React Hook Form
    const { control, errors, handleSubmit, watch } = useForm();
    const password = useRef({});
    password.current = watch("password", "");

    // 所属一覧（店舗一覧のみ。加盟店、代表加盟店は一覧で選択後に編集画面に遷移するため必要なし）
    const [_orgId, setOrgId] = useState(editing.org_id);

    const { classes } = props;

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 保存ボタン押下時の処理
     * 
     */
    const onSubmit = (data, e) => {
        var addNew = (editing.id == null || editing.id == '') ? true : false;
        accountActions.save(token, editing)
            .then(data => {
                if (data && data.error_code > 0) {
                    var message = '更新完了の通知メール送信に失敗しました。';
                    if (addNew) {
                        message = '登録完了の通知メール送信に失敗しました。';
                    }
                    notificationActions.showWarn(message);
                }
                else {
                    // 登録メッセージ表示
                    notificationActions.showSuccess('登録しました。');
                }
                // 詳細画面に戻る
                props.onUpdate();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        const permissionPrefix = 'permission';

        if (name.startsWith(permissionPrefix)) {
            var id = name.substring(permissionPrefix.length, name.length);
            if (currentState.permissions[id] == null) {
                return;
            }
            var permissionType = currentState.permissions[id].type;
            var permissionSetting;

            permissionType.selectables.forEach((p) => {
                if (p.value == value) {
                    permissionSetting = p
                    return;
                }
            });
            if (permissionSetting != null) {
                currentState.permissions[id].value = permissionSetting;
            }

            // フォームを更新
            accountActions.modifyAccount(currentState);
        }
        if (name.startsWith('role')) {
            currentState[name] = value;

            // 所属を初期化
            setOrgId('');
            currentState.org_id = '';
            currentState.org_name = '';

            accountActions.loadSelectableOrgAndPermissions(token, currentState)
                .then(
                    (data) => {
                        // フォームを更新
                        accountActions.modifyAccount(currentState);
                    }
                );
        }
        else {
            currentState[name] = value;
        }

        return value;
    }

    /**
     *
     * 所属リスト選択時の処理
     * （店舗一覧から店舗選択時の処理）
     * 
     * ※
     * 区分選択時に所属の初期化を行っているが、Controllerを被せたコントロールに対して行うと設定が行えないため、
     * Controllerを外して 個別に OnChenge処理を行う
     *
     */
    const onChangeOrg = (e) => {
        let value = e.target.value;
        console.log(`value:${value}`);
        const org = editing.selectableOrgs.find(org => org.id === value);
        setOrgId(org.id);
        editing.org_id = org.id;
        editing.org_name = org.name;
        return value;
    }

    if (editing == null) {
        return <div></div>;
    }

    if (props.createFlag) {
        // 新規作成時は、引数の加盟店IDをセット
        editing.merchant_id = props.merchantId;
    }

    var passwordElement = '';
    var passwordRepeatElement = '';
    if (!editing.id) {
        // 新規の場合のみパスワードの設定
        passwordElement = <Grid item xs={6}>
            <Controller
                name="password"
                control={control}
                onChange={onChange}
                defaultValue={editing.password}
                rules={{ required: <FormattedMessage id={"Error.Required"} />, pattern: { value: /^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])).{8,}$/i, message: <FormattedMessage id="Error.AccountPassWordPattern" /> } }}
                as={<TextField required fullWidth
                    error={errors.password && true}
                    type="password"
                    helperText={errors.password ? errors.password.message : ""}
                    label={<FormattedMessage id={"Account.Password"} />} variant="outlined" />} />
        </Grid>;
        passwordRepeatElement = <Grid item xs={6}>
            <Controller
                name="password_repeat"
                control={control}
                defaultValue={editing.password_repeat}
                onChange={onChange}
                rules={{ required: <FormattedMessage id={"Error.Required"} />, validate: value => value === password.current || <FormattedMessage id="Error.AccountPassWordMatchPattern" /> }}
                as={<TextField required fullWidth
                    error={errors.password_repeat && true}
                    type="password"
                    helperText={errors.password_repeat ? errors.password_repeat.message : ""}
                    label={<FormattedMessage id={"Account.PasswordRepeat"} />} variant="outlined" />} />
        </Grid>;
    }

    // 区分の選択リスト作成
    var orgSelect = '';
    if (userData.role == 1) {
        // システム管理者、沖縄ICアカウント
        if (props.merchantType == 'acquirer') {
            // 選択した加盟店が代表の場合は、区分はブランド、代表と店舗のみ選択可能
            orgSelect =
                <Select
                    labelId="account-role-label"
                    id="account-role"
                    label={<FormattedMessage id={"Account.Role"} />}>
                    <MenuItem value={2}><FormattedMessage id="Account.Role.Brand" /></MenuItem>
                    <MenuItem value={3}><FormattedMessage id="Account.Role.Acquirer" /></MenuItem>
                    <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
                </Select>;
        } else {
            // 選択した加盟店が一般の場合は、区分はブランド、一般と店舗のみ選択可能
            orgSelect =
                <Select
                    labelId="account-role-label"
                    id="account-role"
                    label={<FormattedMessage id={"Account.Role"} />}>
                    <MenuItem value={2}><FormattedMessage id="Account.Role.Brand" /></MenuItem>
                    <MenuItem value={4}><FormattedMessage id="Account.Role.Merchant" /></MenuItem>
                    <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
                </Select>;
        }
    } else if (userData.role == 2) {
        // 沖縄ICアカウント
        if (props.merchantType == 'acquirer') {
            // 選択した加盟店が代表の場合は、区分は代表と店舗のみ選択可能
            orgSelect =
                <Select
                    labelId="account-role-label"
                    id="account-role"
                    label={<FormattedMessage id={"Account.Role"} />}>
                    <MenuItem value={3}><FormattedMessage id="Account.Role.Acquirer" /></MenuItem>
                    <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
                </Select>;
        } else {
            // 選択した加盟店が一般の場合は、区分は一般と店舗のみ選択可能
            orgSelect =
                <Select
                    labelId="account-role-label"
                    id="account-role"
                    label={<FormattedMessage id={"Account.Role"} />}>
                    <MenuItem value={4}><FormattedMessage id="Account.Role.Merchant" /></MenuItem>
                    <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
                </Select>;
        }
    } else if (userData.role == 3) {
        // 代表加盟店アカウント
        if (userData.org_id == '00000000-0000-0000-0000-000000000001') {
            //  MC代表加盟店の場合は、加盟店一覧画面で加盟店を選択して遷移
            orgSelect =
                <Select
                    labelId="account-role-label"
                    id="account-role"
                    label={<FormattedMessage id={"Account.Role"} />}>
                    <MenuItem value={4}><FormattedMessage id="Account.Role.Merchant" /></MenuItem>
                    <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
                </Select>;
        } else {
            //  通常の代表加盟店の場合は、加盟店一覧画面を表示せず店舗ユーザのみ対象
            orgSelect =
                <Select
                    labelId="account-role-label"
                    id="account-role"
                    label={<FormattedMessage id={"Account.Role"} />}>
                    <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
                </Select>;
        }
    } else if (userData.role == 4) {
        // 加盟店アカウント
        // 店舗のみなので非活性で選択不可に
        orgSelect =
            <Select
                disabled
                labelId="account-role-label"
                id="account-role"
                label={<FormattedMessage id={"Account.Role"} />}>
                <MenuItem value={5}><FormattedMessage id="Account.Role.Store" /></MenuItem>
            </Select>;
    } else if (userData.role == 5) {
        // 店舗アカウント
        // 店舗管理の編集は行わない。
        return <div></div>;
    }

    // 所属の選択リスト作成
    var orgElement = '';
    if (editing.role == 3 || editing.role == 4) {
        // 選択している区分が、代表加盟店/加盟店の場合は選択された加盟店名を所属として表示
        editing.org_id = props.merchantId;
        editing.org_name = props.merchantName;
        orgElement =
            <Grid item xs={12}>
                <Controller
                    name="merchant_name"
                    control={control}
                    defaultValue={props.merchantName}
                    as={<TextField disabled fullWidth variant="outlined"
                        label={<FormattedMessage id={"Shop.Merchant"} />} />} />
            </Grid>;
    }
    else if (editing.role == 5) {
        // 選択している区分が、店舗の場合は配下の店舗一覧を所属としてリスト表示（活性）
        orgElement =
            <Grid item xs={12}>
                <FormControl required fullWidth variant="outlined" error={errors.org_id && true}>
                    <InputLabel id="account-org-label"><FormattedMessage id={"Account.Org"} /></InputLabel>
                    <Select
                        name="org_id"
                        control={control}
                        onChange={onChangeOrg}
                        value={_orgId}
                        rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                        labelId="account-org-label"
                        id="account-org"
                        label={<FormattedMessage id={"Account.Org"} />}>
                        {editing.selectableOrgs.map((org) => {
                            return <MenuItem key={org.id} value={org.id}>{org.name}</MenuItem>
                        })}
                    </Select>
                    <FormHelperText>{errors.org_id ? errors.org_id.message : ""}</FormHelperText>
                </FormControl>
            </Grid>;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Account.CreateTitle" />}</Typography>
                        <Typography component="h2" variant="subtitle2">{<FormattedMessage id="Account.CreateDesc" />}</Typography>
                    </div>
                </Toolbar>

                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>                       
                        <Grid item xs={6}>
                            <Controller
                                name="username"
                                control={control}
                                defaultValue={editing.username}
                                onChange={onChange}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 256, message: <FormattedMessage id="Error.AccountEmailPattern" /> },
                                    pattern: { value: /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/i, message: <FormattedMessage id="Error.Email" /> }
                                }}
                                as={<TextField required fullWidth
                                        error={errors.username && true}
                                        helperText={errors.username ? errors.username.message : "例) okinawa_taro@okica.jp"}
                                        label={<FormattedMessage id={"Account.Username"} />} variant="outlined" />} />

                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="name"
                                control={control}
                                onChange={onChange}
                                defaultValue={editing.name}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 128, message: <FormattedMessage id="Error.AccountNamePattern" /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                        error={errors.name && true}
                                        helperText={errors.name ? errors.name.message : "例) 沖縄 太郎"}
                                        label={<FormattedMessage id={"Account.Name"} />} />} />
                        </Grid>

                        {passwordElement}
                        {passwordRepeatElement}

                        <Grid item xs={6}>
                            <FormControl required fullWidth variant="outlined">
                                <InputLabel id="account-role-label"><FormattedMessage id={"Account.Role"} /></InputLabel>
                                <Controller
                                    name="role"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={editing.role}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    as={orgSelect} />
                            </FormControl>
                        </Grid>

                        {orgElement}

                        <Grid item xs={12}>
                            <Typography component="h2" variant="inherit">{<FormattedMessage id="Account.Permission" />}</Typography>
                            <Divider />
                        </Grid>

                        {editing.availablePermissionTypes.map((permissionType) => {
                            return (
                                <Grid item xs={6} key={permissionType.id}>
                                    <FormControl variant="outlined" required fullWidth>
                                        <InputLabel id={"permission" + permissionType.id + "-label"}>{permissionType.name}</InputLabel>
                                        <Controller
                                            name={"permission" + permissionType.id}
                                            control={control}
                                            defaultValue={editing.permissions[permissionType.id] ? editing.permissions[permissionType.id].value.value : 0}
                                            onChange={onChange}
                                            rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                            as={<Select
                                                    labelId={"permission" + permissionType.id + "-label"}
                                                    id={"permission" + permissionType.id}
                                                    label={permissionType.name}>

                                                    {permissionType.selectables.map((permissionValue) => {
                                                        return <MenuItem key={permissionValue.value} value={permissionValue.value}>{permissionValue.title}</MenuItem>
                                                    })}
                                                </Select>} />
                                    </FormControl>
                                </Grid>
                            )
                        })}

                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                            </Grid>
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium" color="primary"
                                    onClick={handleSubmit(onSubmit)}
                                    endIcon={<SaveIcon />}><FormattedMessage id="Button.Save" /></Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(AccountEdit);
